import { defineMessages } from 'react-intl';

export default defineMessages({
  replyLabel: {
    id: 'frontbucket.repository.pullRequestConversation.replyLabel',
    description: 'Text label reply comment action',
    defaultMessage: 'Reply',
  },
  resolveLabel: {
    id: 'frontbucket.repository.pullRequestConversation.resolveLable',
    description: 'Text label resolve comment action',
    defaultMessage: 'Resolve',
  },
  reopenLabel: {
    id: 'frontbucket.repository.pullRequestConversation.reopenLabel',
    description: 'Text label reopen comment action',
    defaultMessage: 'Reopen',
  },
  editLabel: {
    id: 'frontbucket.repository.pullRequestConversation.editLabel',
    description: 'Text label edit comment action',
    defaultMessage: 'Edit',
  },
  deleteLabel: {
    id: 'frontbucket.repository.pullRequestConversation.deleteLabel',
    description: 'Text label delete comment action',
    defaultMessage: 'Delete',
  },
  deletedComment: {
    id: 'frontbucket.conversation.deletedComment',
    description:
      'Message shown in place of a comment that was deleted from the middle of a conversation thread',
    defaultMessage: 'Comment deleted',
  },
  pendingLozenge: {
    id: 'frontbucket.repository.pullRequestConversation.pendingLozenge',
    description: 'Text label if comment is pending',
    defaultMessage: 'Pending',
  },
});
